// Loading Stripe.js, once.
//
// Stripe requires js.stripe.com to be loaded directly from Stripe — bundling it
// is not permitted, and the published npm package is only a loader around the
// same script tag. So this is that loader, without the dependency.
//
// The card form it powers runs entirely inside a Stripe-hosted iframe: the
// number and CVC are typed into Stripe's own fields and posted to Stripe with a
// SetupIntent client secret. They never enter this app's DOM, its bundle, its
// functions or its database — which is the whole reason for doing it this way.

const SRC = "https://js.stripe.com/v3/";
let loading = null;

// The publishable key is a public, build-time value (pk_...), safe to ship. When
// it is absent the card form is simply unavailable, and the caller says so.
export function publishableKey() {
  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
}

export function stripeConfigured() {
  return Boolean(publishableKey());
}

// Resolves with a Stripe instance, or null if it cannot be used here.
export function loadStripe() {
  if (typeof window === "undefined") return Promise.resolve(null);
  if (!stripeConfigured()) return Promise.resolve(null);
  if (window.Stripe) return Promise.resolve(window.Stripe(publishableKey()));
  if (loading) return loading;

  loading = new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${SRC}"]`);
    const done = () => resolve(window.Stripe ? window.Stripe(publishableKey()) : null);
    if (existing) { existing.addEventListener("load", done); existing.addEventListener("error", () => resolve(null)); return; }
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    s.onload = done;
    s.onerror = () => resolve(null);
    document.head.appendChild(s);
  });
  return loading;
}

// Tests only.
export function _resetStripeJsLoader() { loading = null; }
